<template>
<div>
	<div class="row">
		<div class="col-12">
			<fl-anexo :accept="'application/pdf'"
						@dados-anexo="(dados) => recebeAnexo(dados)" />
		</div>
		<div class="col-12" v-show="existeAnexo">
			<table class="table table-hover">
				<thead>
					<tr>
						<th>Arquivos Adicionados:</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in anexos" :key="index " >
						<td v-if="!item.excluir">
							<div>
								<a style="color:#1E88E5; cursor:pointer"
									v-tooltip="'Clique para exibir o arquivo'"
									:href="item.url"
									target="_blank">
									{{item.nomeArquivo}}
								</a>
								<a class="float-right"
									href="#"
									style="color:red"
									v-if="!visualizar"
									@click.prevent="excluirAnexo(index)">
									<fa-icon :icon="['far', 'trash-alt']"  /> Excluir
								</a>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
</template>

<script>
import flAnexo from '../../../../../../components/upload-file/main.vue'
export default {

	components: {
		flAnexo,
	},

	props: ['anexo', 'visualizar'],

	computed: {
		anexos () {
			return _.orderBy(this.form.anexo, ['asc'])
		},

		existeAnexo() {
			return this.form.anexo.some(anexo => !anexo.excluir)
		}
	},

	data () {
		return {
			form: {
				anexo: this.anexo
			}
		}
	},

	methods: {
		recebeAnexo(dados){
			for(let i in dados){
				this.form.anexo.push({
					idInspecao: this.form.id,
					excluir: false,
					base64: dados[i].base64,
					nomeArquivo: dados[i].nomeArquivo
				})
			}
		},

		excluirAnexo(index){
			if (this.form.anexo[index].id != 0) {
				this.form.anexo[index].excluir = true;
			} else {
				this.form.anexo.splice(index, 1);
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/inspecao/components/arquivos.vue